"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePhysicsTick = exports.onRapierLoaded = exports.timestep = exports.isLoaded = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfPlacerSensor_sidecar_1 = require("../entities/minigolfPlacerSensor-sidecar");
// import { IMinigolfPuck } from '../entities/minigolfPucks'
var minigolfPhysics_contactHandler_sidecar_1 = require("./minigolfPhysics_contactHandler-sidecar");
var minigolfPhysics_intersectionHandler_sidecar_1 = require("./minigolfPhysics_intersectionHandler-sidecar");
var minigolfCheckForAllStill_sidecar_1 = require("../entities/minigolfCheckForAllStill-sidecar");
var namespace = 'minigolf-physics-rapier-loader';
// import('@dimforge/rapier2d-compat').then((RAPIER) => {
//   onRapierLoaded(RAPIER)
// })
var rapier2d_compat_1 = __importDefault(require("@dimforge/rapier2d-compat"));
var _obj = null;
function get() {
    assert_sidecar_1.assert.notNil(_obj, 'rapier not loaded');
    return _obj;
}
exports.get = get;
function isLoaded() {
    return _obj !== null;
}
exports.isLoaded = isLoaded;
exports.timestep = 1 / 120;
// export const timestep = 1 / 60
// export const timestep = 1 / 30
// export const timestep = 1 / 101
var load = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rapier2d_compat_1.default.init()];
            case 1:
                _a.sent();
                exports.onRapierLoaded();
                return [2 /*return*/];
        }
    });
}); };
load();
var onRapierLoaded = function () { return __awaiter(void 0, void 0, void 0, function () {
    var RA, gravity, world, eventQueue;
    return __generator(this, function (_a) {
        console.log(namespace, 'onRapierLoaded');
        RA = rapier2d_compat_1.default;
        gravity = { x: 0, y: 0 };
        world = new RA.World(gravity);
        world.timestep = exports.timestep;
        eventQueue = new RA.EventQueue(true);
        _obj = {
            RA: RA,
            world: world,
            elapsedSeconds: 0,
            eventQueue: eventQueue,
            physicsStepsSimulatedCount: 0,
        };
        // Create extras
        // minigolfBoundaries.create()
        minigolfPlacerSensor_sidecar_1.minigolfPlacerSensor.create();
        console.log(namespace, 'onRapierLoaded', 'complete');
        return [2 /*return*/];
    });
}); };
exports.onRapierLoaded = onRapierLoaded;
// export const updatePhysics_localhost = (elapsedSeconds: number) => {
//   if (!isLoaded()) {
//     return
//   }
//   // console.log(namespace, 'updatePhysics1', get().elapsedSeconds, elapsedSeconds)
//   let maxSteps = 10
//   if (elapsedSeconds > timestep * maxSteps) {
//     elapsedSeconds = timestep * maxSteps
//   }
//   get().elapsedSeconds += elapsedSeconds
//   while (get().elapsedSeconds >= timestep) {
//     updatePhysicsTick(true)
//     get().elapsedSeconds -= timestep
//   }
//   // console.log(namespace, 'updatePhysics2', get().elapsedSeconds, elapsedSeconds)
//   // updatePhysicsTick(false, true)
// }
// export const updatePhysics_networked = (steps: number) => {
//   if (!isLoaded()) {
//     return
//   }
//   let i = 0
//   while (i < steps) {
//     i++
//     updatePhysicsTick(true)
//   }
//   // console.log(namespace, 'updatePhysics2', get().elapsedSeconds, elapsedSeconds)
//   // updatePhysicsTick(false, true)
// }
// export const updatePhysics_localhost = (elapsedSeconds: number) => {
//   if (!isLoaded()) {
//     return
//   }
//   // console.log(namespace, 'updatePhysics1', get().elapsedSeconds, elapsedSeconds)
//   let maxSteps = 10
//   if (elapsedSeconds > timestep * maxSteps) {
//     elapsedSeconds = timestep * maxSteps
//   }
//   get().elapsedSeconds += elapsedSeconds
//   while (get().elapsedSeconds >= timestep) {
//     updatePhysicsTick(true)
//     get().elapsedSeconds -= timestep
//   }
//   // console.log(namespace, 'updatePhysics2', get().elapsedSeconds, elapsedSeconds)
//   // updatePhysicsTick(false, true)
// }
var updatePhysicsTick = function (step) {
    if (!isLoaded()) {
        return;
    }
    var _a = get(), world = _a.world, eventQueue = _a.eventQueue;
    if (step) {
        // minigolfPucks.updateAllPhysicsTick()
        // minigolfBlocks.updateAllPhysicsTick()
        minigolfCreatures_sidecar_1.minigolfCreatures.updateAllPhysicsTick();
        minigolfCheckForAllStill_sidecar_1.minigolfCheckForAllStill.checkForAllStill();
        minigolfPlacerSensor_sidecar_1.minigolfPlacerSensor.updateAllPhysicsTick();
    }
    // Step the simulation forward.
    if (step) {
        get().physicsStepsSimulatedCount++;
        world.step(eventQueue);
        minigolfPhysics_contactHandler_sidecar_1.minigolfPhysics_contactHandler.processPhysicsEventQueue(eventQueue);
        minigolfPhysics_intersectionHandler_sidecar_1.minigolfPhysics_intersectionHandler.processIntersections(world);
    }
    // TODO: move renderer elsewhere?
    // if (render) {
    // minigolfRenderer.render()
    // }
};
exports.updatePhysicsTick = updatePhysicsTick;
